export var cardFooter = {
    defaultProps: {
        className: ""
    },
    styles: {
        base: {
            initial: {
                p: "p-6"
            },
            divider: {
                borderWidth: "border-t",
                borderColor: "border-blue-grey-50"
            }
        }
    }
};
export default cardFooter;
